'use client'

import { createContext, useContext, useState } from 'react'

type PackageTabs = { value: string; label: string }[]
const tabs: PackageTabs = [
  { value: 'au', label: 'Australia' },
  { value: 'nz', label: 'New Zealand' },
]

const PackageContext = createContext<{
  tab: string
  setTab: (tab: string) => void
  tabs: PackageTabs
}>({
  tab: 'au',
  setTab: () => {},
  tabs,
})

export function usePackageContext() {
  return useContext(PackageContext)
}

export function PackageProvider({ children }: { children?: React.ReactNode }) {
  const [tab, setTab] = useState(tabs[0].value)
  return (
    <PackageContext.Provider value={{ tab, setTab, tabs }}>
      {children}
    </PackageContext.Provider>
  )
}
